























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProjectLaborType, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'projectLaborType',
  }),
  mixins: [paginationMixin],
})
export default class ProjectLaborTypeList extends Vue {
  @Action('getEntities', { namespace: 'projectLaborType' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'projectLaborType' })
  entitiesSlice: IProjectLaborType[];
  @State('pageParams', { namespace: 'projectLaborType' })
  pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'title' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
